<template>
  <div class="container">
    <div class="title reveal-bottom">
      <p class="title-h">{{ $t("h.we") }}</p>
      <p class="title-cont">
        {{ $t("h.wec") }}
      </p>
    </div>
    <div class="box">
      <div class="que reveal-bottom">
        <div class="icon">
          <img
            class="icon"
            :src="require('@/assets/img_svg/home_intro_icon_1.svg')"
            alt="svg"
          />
        </div>
        <div class="que-cont">
          <h4>{{ $t("h.what") }}</h4>
          <p>
            {{ $t("h.whatc") }}<br />
            {{ $t("h.whatc1") }}<br />
            {{ $t("h.whatc2") }}
          </p>
        </div>
      </div>
      <div class="que reveal-bottom">
        <div class="icon">
          <img
            class="icon"
            :src="require('@/assets/img_svg/home_intro_icon_2.svg')"
            alt="svg"
          />
        </div>
        <div class="que-cont">
          <h4>{{ $t("h.why") }}</h4>
          <p>
            {{ $t("h.whyc") }}<br />
            {{ $t("h.whyc1") }}<br />
            {{ $t("h.whyc2") }}
          </p>
        </div>
      </div>
      <div class="que que-bottom reveal-bottom">
        <div class="icon">
          <img
            class="icon"
            :src="require('@/assets/img_svg/home_intro_icon_3.svg')"
            alt="svg"
          />
        </div>
        <div class="que-cont">
          <h4>{{ $t("h.di") }}</h4>
          <p>
            {{ $t("h.dic") }}<br />
            {{ $t("h.dic1") }}<br />
            {{ $t("h.dic2") }}
          </p>
        </div>
      </div>
      <div class="que que-bottom reveal-bottom">
        <div class="icon">
          <img
            class="icon"
            :src="require('@/assets/img_svg/home_intro_icon_4.svg')"
            alt="svg"
          />
        </div>
        <div class="que-cont">
          <h4>{{ $t("h.xian") }}</h4>
          <p>
            {{ $t("h.xianc") }}<br />
            {{ $t("h.xianc1") }}<br />
            {{ $t("h.xianc2") }}
          </p>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="bottom-left">
        <div class="bottom-title reveal-bottom">
          <span class="new-title">{{ $t("h.new") }}</span>
          <router-link to="/News" class="title-more"
            >{{ $t("h.more") }} ></router-link
          >
        </div>
        <router-link to="/NewDetail/1" class="new-cont reveal-bottom">
          <img :src="require('@/assets/images/home_new.png')" alt="11" />
          <div class="new-box">
            <div class="new-title111">
              深圳睿网云联科技有限公司的云快线智能组网产品分别通过SD-WAN
              Ready的设备、解决方案以及服务认证
            </div>
            <p class="new-time">2020-06-29</p>
            <p class="new-show" v-ellipsis>{{ cont }}</p>
          </div>
        </router-link>
        <div style="margin-top: 12px" class="reveal-bottom">
          <router-link to="/NewDetail/2" class="new-li">
            <p>
              深圳睿网云联科技有限公司的云快线智能组网产品分别通过SD-WAN
              Ready的设备、解决方案以及服务认证
            </p>
            <span>2020-08-14</span>
          </router-link>
          <!-- <div class="new-li">
                        <p>BINH推出心领域研究邀请</p>
                        <span>2010-10-12</span>
                    </div>
                    <div class="new-li">
                        <p>BINH推出心领域研究邀请</p>
                        <span>2010-10-12</span>
                    </div> -->
        </div>
      </div>
      <div class="bottom-right">
        <div class="bottom-title reveal-bottom">
          <span class="new-title">{{ $t("h.About") }}</span>
        </div>
        <div
          class="video-box reveal-bottom"
          :style="{ backgroundImage: 'url(' + img + ')' }"
          @click="start"
        >
          <img
            class="video-img"
            :src="require('@/assets/img_svg/video_play_icon.svg')"
            alt="svg"
          />
        </div>
      </div>
    </div>
    <Video ref="child" />
  </div>
</template>
<script>
import Video from "./Video";
export default {
  data() {
    return {
      img: require("@/assets/images/videoInit.png"),
      cont: "2020年6月2日--6月29日，深圳睿网云联科技有限公司（以下简称“睿网云联”）参加了由CCSA SNAI推委会（TC610）SDN集成与互通测试组发起的“SD-WAN Ready”测试项目，并已顺利通过该项测试。通过此次测试，表明睿网云联SD-WAN产品的技术规范性和专业性得到了充分肯定。截止目前，已有...",
    };
  },
  mounted() {
    console.log(this.tt);
  },
  methods: {
    start() {
      this.$refs.child.start();
    },
  },

  components: {
    Video,
  },
};
</script>

<style scoped>
.container {
  width: 1200px;
  margin: 0 auto;
  padding: 0 10px;
  box-sizing: border-box;
}
.title {
  margin-top: 149px;
  text-align: center;
}
.title-h {
  font-size: 44px;
  line-height: 62px;
  color: #000;
  font-family: Helvetica, "PingFang SC", "Microsoft Yahei",
    "WenQuanYi Micro Hei", Arial, Verdana, sans-serif;
  font-weight: bold;
}
.title-cont {
  font-family: Helvetica, "PingFang SC", "Microsoft Yahei",
    "WenQuanYi Micro Hei", Arial, Verdana, sans-serif;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.5);
  text-align: center;
  text-align: center;
  margin: 20px auto 0;
  line-height: 25px;
}
.box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 85px;
  color: #000;
}
.que {
  /* flex-basis:600px; */
  height: 120px;
  display: flex;
}
.icon {
  width: 120px;
  height: 120px;
}
.que-cont {
  width: 382px;
  margin-left: 32px;
}
.que-cont > h4 {
  color: #333;
  font-size: 22px;
  line-height: 30px;
  letter-spacing: 0;
  font-family: Helvetica, "PingFang SC", "Microsoft Yahei",
    "WenQuanYi Micro Hei", Arial, Verdana, sans-serif;
}
.que-cont > p {
  font-size: 18px;
  line-height: 32px;
  color: rgba(0, 0, 0, 0.5);
  height: 96px;
}
.que-bottom {
  margin-top: 80px;
}
.bottom {
  display: flex;
  height: 367px;
  margin-top: 98px;
  margin-bottom: 118px;
  color: #000;
}
.bottom-left {
  flex: 1;
}
.bottom-right {
  flex: 1;
  margin-left: 70px;
}
.bottom-title {
  height: 45px;
  line-height: 45px;
}
.new-title {
  font-size: 32px;
  font-weight: bold;
  color: #000;
}
.title-more {
  float: right;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.5);
  cursor: pointer;
}
.new-cont {
  height: 200px;
  margin-top: 22px;
  display: flex;
}
.new-cont > img {
  width: 250px;
  height: 200px;
}
.new-box {
  margin-left: 27px;
}
.new-title111 {
  display: inline-block;
  color: #000;
  font-size: 16px;
  line-height: 24px;
  height: 24px;
  width: 278px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.new-time {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.2);
  margin-top: 8px;
  line-height: 18px;
  margin-bottom: 13px;
}
.new-show {
  font-size: 12px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.8);
  letter-spacing: 0.1px;
  height: 130px;
}
.new-li {
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  color: #000;
}

.new-li > p {
  float: left;
  width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.new-li > p:hover {
  text-decoration: underline;
}
.new-li > span {
  float: right;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.2);
}

.video-box {
  display: block;
  width: 540px;
  height: 300px;
  position: relative;
  margin-left: 10px;
  cursor: pointer;
}
.video-img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 40px;
}
</style>



// WEBPACK FOOTER //
// src/Pages/Home/Content0.vue